export const path = "/crm-roundler";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "COMERCIAL",
  section: "ROUNDLER",
  group: null,
  order: 7,
  roles: [
    "Authenticated",
    "roundler-admin",
    "master-rrss-roundler",
  ],
};
